import { supabase } from "@/lib/supabase/supabaseClient"
import { AddQuestionToSurveyBankQuestionBankProps } from "."

export const addQuestionsToSurveyBankQuestionBank = async (props: AddQuestionToSurveyBankQuestionBankProps[]) => {
    const questionsForQuestionBank = props.filter(q => !q.question_bank_ref_id).map(q => ({
        ...q,
        field_type_context_stack: [
            ...(q.field_type_context_stack || []),
            {
                crm_system: q.crm_system,
                field_type: q.field_type
            }
        ],
    }));
    const questionsForQuestionBankStrapped = questionsForQuestionBank
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .map(({ question_bank_ref_id, survey_bank_id, ...q}) => ({
            ...q,
            // Question in question bank should have selected_configuration.conditionals set to default values
            selected_configuration: {
                parameter: q?.selected_configuration?.parameter,
                conditionals: {
                    enabled: false,
                    where: {
                        or: [{ and: [] }]
                    },
                }
            },
        }))
        
    let questionsForSurveyBank = props
        .filter(q => q.question_bank_ref_id);
    const { data: addToQuestionBankData, error: addToQuestionBankError } = await supabase.from('question_bank').insert(questionsForQuestionBankStrapped).select()
    if (addToQuestionBankError) {
        console.error(addToQuestionBankError)
    }

    
    const questionsForSurveyBankFromQuestionBank = questionsForQuestionBank
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .map((q, i) => ({ ...q, question_bank_ref_id: addToQuestionBankData?.[i].id }))
    questionsForSurveyBank = [...questionsForSurveyBank, ...questionsForSurveyBankFromQuestionBank];
    return await supabase.from('survey_bank_question_bank').insert(questionsForSurveyBank)
    .select()
}
